const pageNameKey = "timezoneStringInfo";

export const timezoneStringInfoEn = {
  [pageNameKey]: {
    linkText: "Chosen timezone",
    noneText: "None (UTC)",
    toolTipText: "Current timezone setting",
  },
};

export const timezoneStringInfoPtBr = {
  [pageNameKey]: {
    linkText: "Fuso horário selecionado",
    noneText: "Nenhum (UTC)",
    toolTipText: "Configuração atual do fuso horário",
  },
};

export const timezoneStringInfoDe = {
  [pageNameKey]: {
    linkText: "Gewählte Zeitzone",
    noneText: "Keine (UTC)",
    toolTipText: "Aktuelle Zeitzoneneinstellung",
  },
};

export const timezoneStringInfoZhHans = {
  [pageNameKey]: {
    linkText: "选择的时区",
    noneText: "无 (UTC)",
    toolTipText: "当前时区设置",
  },
};

export const timezoneStringInfoIt = {
  [pageNameKey]: {
    linkText: "Fuso orario scelto",
    noneText: "Nessuno (UTC)",
    toolTipText: "Impostazione fuso orario corrente",
  },
};

export const timezoneStringInfoEs = {
  [pageNameKey]: {
    linkText: "Zona horaria elegida",
    noneText: "Ninguno (UTC)",
    toolTipText: "Configuración actual de la zona horaria",
  },
};

export const timezoneStringInfoNl = {
  [pageNameKey]: {
    linkText: "Gekozen tijdzone",
    noneText: "Geen (UTC)",
    toolTipText: "Huidige tijdzone-instelling",
  },
};

export const timezoneStringInfoTr = {
  [pageNameKey]: {
    linkText: "Seçilen saat dilimi",
    noneText: "Hiçbiri (UTC)",
    toolTipText: "Geçerli saat dilimi ayarı",
  },
};
